import axios from "axios";
import { toast } from "react-toastify";
import axiosClient from "./axiosClient";


export const fetchTemplates = async (params) => {
    try {
      const response = await axiosClient.get(`/user-service/templates` , {params});
  
      if (response?.status === "SUCCESS") {
        return response;
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("Error fetching total patient count:", err);
      toast.error("An error occurred while fetching templates.");
    }
  };

export const AddTemplate = async (data , id = null) => {
    try {
      
      const response = await axiosClient.post(`/user-service/templates` , data);

      
  
      if (response?.status === "SUCCESS") {
        return response;
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("Error fetching total patient count:", err);
      toast.error("An error occurred while fetching templates.");
    }
  };